import React from 'react';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import InfoLabel from 'UI/components/molecules/InfoLabel';
import { ENTITY_PROFILES_ROUTES_MAP, EntityType } from 'UI/constants/entityTypes';

export const JobOrderDetails = ({ jobOrder, company }) => {
  return (
    <Grid container>
      <Grid item xs={6}>
        <InfoLabel
          title={company.title}
          description={company.name}
          mode="localLink"
          linkProps={{
            type: 'local',
            url: ENTITY_PROFILES_ROUTES_MAP[EntityType.Company].replace(':id', company.id),
            target: '_blank'
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <InfoLabel
          title={jobOrder.title}
          description={jobOrder.name}
          mode="localLink"
          linkProps={{
            type: 'local',
            url: ENTITY_PROFILES_ROUTES_MAP[EntityType.Joborder].replace(':id', jobOrder.id),
            target: '_blank'
          }}
        />
      </Grid>

      <Divider />
    </Grid>
  );
};
